import { gql } from '@apollo/client'

export const NEEDS_USER_SURVEY_UPDATE = gql`
  query NeedsUserSurveyUpdate {
    needsUserSurveyUpdate
  }
`
